<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
<!--      <a-button @click="handleAdd" type="primary" icon="plus">{{$t('button.add')}}</a-button>-->
<!--      <a-button type="primary" icon="download" @click="handleExportXls('efs_std_margin')">{{$t('button.export')}}</a-button>-->
<!--      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">-->
<!--        <a-button type="primary" icon="import">{{$t('button.import')}}</a-button>-->
<!--      </a-upload>-->
<!--      <a-dropdown v-if="selectedRowKeys.length > 0">-->
<!--        <a-menu slot="overlay">-->
<!--          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>{{$t('button.delete')}}</a-menu-item>-->
<!--        </a-menu>-->
<!--        <a-button style="margin-left: 8px"> {{$t('button.batchOperation')}} <a-icon type="down" /></a-button>-->
<!--      </a-dropdown>-->
    </div>

    <!-- table区域-begin -->
    <div>

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        class="j-table-force-nowrap"
        :scroll="{x:true}"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无图片</span>
          <img v-else :src="getImgView(text)" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无文件</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)">
            下载
          </a-button>
        </template>

        <span slot="action" slot-scope="text, record">
<!--          <a @click="handleEdit(record)">{{$t('button.edit')}}</a>-->
              <a @click="handleDetail(record)">{{$t('button.details')}}</a>

          <a-divider v-if="record.approvalStatus=='00'"type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">{{$t('button.more')}} <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item v-if="record.approvalStatus=='00'">
                <a-popconfirm :title="$t('tip.makeSureTheReviewIsApproved')" @confirm="() => handlePass(record.id)">
                  <a>{{$t('button.reviewApproved')}}</a>
                </a-popconfirm>
              </a-menu-item>
              <a-menu-item v-if="record.approvalStatus=='00'">
                  <a-popconfirm :title="$t('tip.rejected')" @confirm="() => handleFailure(record.id)">
                 <a>{{$t('button.rejected')}}</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>

    <efs-std-margin-modal ref="modalForm" @ok="modalFormOk"/>
  </a-card>
</template>

<script>

  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import EfsStdMarginModal from './modules/EfsStdMarginModal'
  import '@/assets/less/TableExpand.less'
  import { putAction } from '@api/manage'

  export default {
    name: "EfsStdMarginList",
    mixins:[JeecgListMixin],
    components: {
      EfsStdMarginModal
    },
    data () {
      return {
        description: 'efs_std_margin管理页面',
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title:'合同单号',
            align:"center",
            dataIndex: 'conCode'
          },
          {
            title:'批次编号',
            align:"center",
            dataIndex: 'breedBatchCode'
          },
          {
            slotName: 'tableHeader.grower',
            scopedSlots: { title: 'tableHeader.grower'},
            align:"center",
            dataIndex: 'farmerCode_dictText'
          },
          {
            slotName: 'tableHeader.farms',
            align:"center",
            dataIndex: 'farmCode_dictText',
            scopedSlots: { title: 'tableHeader.farms'}
          },
          {
            title:'合同数量',
            align:"center",
            dataIndex: 'conQty'
          },
          {
            title:'实际进苗数量',
            align:"center",
            dataIndex: 'actQty'
          },
          {
             slotName: 'tableHeader.unitPrice',
            scopedSlots: { title: 'tableHeader.unitPrice'},
            align:"center",
            dataIndex: 'unitPrice'
          },
          {
            title:'余额',
            align:"center",
            dataIndex: 'balance'
          },
          {
            slotName: 'tableHeader.amount',
            scopedSlots: { title: 'tableHeader.amount'},
            align:"center",
            dataIndex: 'amount'
          },
          {
            title:'累计上缴金额',
            align:"center",
            dataIndex: 'addAmount'
          },
          {
            title:'上缴日期',
            align:"center",
            dataIndex: 'postDate',
            customRender:function (text) {
              return !text?"":(text.length>10?text.substr(0,10):text)
            }
          },
          {
            title:'上缴人',
            align:"center",
            dataIndex: 'applicant'
          },
          {
            slotName: 'tableHeader.lastApprover',
            scopedSlots: { title: 'tableHeader.lastApprover'},
            align:"center",
            dataIndex: 'lastApprover'
          },
          {
            slotName: 'tableHeader.lastApprovalTime',
            scopedSlots: { title: 'tableHeader.lastApprovalTime'},
            align:"center",
            dataIndex: 'lastApproveTime',
            customRender:function (text) {
              return !text?"":(text.length>10?text.substr(0,10):text)
            }
          },
          {
            slotName: 'tableHeader.reviewStatus',
            scopedSlots: { title: 'tableHeader.reviewStatus'},
            align:"center",
            dataIndex: 'approvalStatus_dictText'
          },
          {
            slotName: 'tableHeader.operation',
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            scopedSlots: { customRender: 'action', title: 'tableHeader.operation' },
          }
        ],
        url: {
          list: "/depositRecord/efsStdMargin/list",
          delete: "/depositRecord/efsStdMargin/delete",
          deleteBatch: "/depositRecord/efsStdMargin/deleteBatch",
          exportXlsUrl: "/depositRecord/efsStdMargin/exportXls",
          importExcelUrl: "depositRecord/efsStdMargin/importExcel",

        },
        dictOptions:{},
      }
    },
    created() {
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      }
    },
    methods: {
      initDictConfig(){
      },
      handleFailure(id){
        putAction('/depositRecord/efsStdMargin/updateApprovalStatus', {"id": id, "approvalStatus": "40"}).then((res) => {
          if (res.success) {
            this.$message.success(res.message);
            this.loadData();
          } else {
            this.$message.error(res.message);
          }
        })
      },
      handlePass(id){
        putAction('/depositRecord/efsStdMargin/updateApprovalStatus', {"id": id, "approvalStatus": "30"}).then((res) => {
          if (res.success) {
            this.$message.success(res.message);
            this.loadData();
          } else {
            this.$message.error(res.message);
          }
        })
      },
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>